import { render, staticRenderFns } from "./PictureSlide.vue?vue&type=template&id=2006c22e"
import script from "./PictureSlide.vue?vue&type=script&lang=ts"
export * from "./PictureSlide.vue?vue&type=script&lang=ts"
import style0 from "./PictureSlide.vue?vue&type=style&index=0&id=2006c22e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports